import { HttpContext } from '@angular/common/http';
import { SKIP_TOAST } from '../tokens';

export const skipToastContext: (value: boolean) => HttpContext = (value: boolean) =>
  new HttpContext().set(SKIP_TOAST, value);
